// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/full-page-image-banner/full-page-image-banner.component.scss
// module id = 336
// module chunks = 0